import { Node } from 'prosemirror-model'
import { EditorState } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'
import { createContext } from 'react'

export const EditorDocContext = createContext<Node | null>(null)
export const EditorStateContext = createContext<EditorState | null>(null)
export const EditorViewContext = createContext<EditorView | null>(null)

export const { Provider: EditorDocProvider } = EditorDocContext
export const { Provider: EditorStateProvider } = EditorStateContext
export const { Provider: EditorViewProvider } = EditorViewContext
